import { render } from "./CreateClientLogoPage.vue?vue&type=template&id=a13ec6f8"
import script from "./CreateClientLogoPage.vue?vue&type=script&lang=js"
export * from "./CreateClientLogoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__